var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contents5" }, [
    _c("img", { staticClass: "bg", attrs: { src: _vm.bgImg } }),
    _vm._v(" "),
    _c("div", { staticClass: "contents" }, [
      _c("p", { staticClass: "text1" }, [
        _vm._v("B2B "),
        _vm.isMobile ? _c("br") : _vm._e(),
        _vm._v("스마트 관제 서비스")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "text2" }, [
        _vm._v("\n      고객사 시스템 연동을 통한 "),
        _vm.isMobile ? _c("br") : _vm._e(),
        _vm._v("정비 이력 관리 환경 제공"),
        _c("br"),
        _vm._v("\n      실시간 모니터링 및 정산 자동화"),
        _c("br"),
        _vm._v("\n      서비스 품질 관리"),
        _c("br"),
        _vm._v("\n      표준화된 순회 정비 서비스"),
        _c("br"),
        _vm._v("\n      전국 순회 정비망 구축\n    ")
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33e0c7cc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33e0c7cc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents/main/Contents5.vue
// module id = null
// module chunks = 